import type { Resource } from '../../';
export const forms_field_firstName: Resource = {"default":"First Name"};
